import { toPng } from 'html-to-image';

export const captureChartElement = async (element, filename) => {
  if (!element) {
    throw new Error('Element not found');
  }

  try {
    document.body.style.cursor = 'wait';
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const width = element.offsetWidth;
    const height = element.offsetHeight;
    
    const dataUrl = await toPng(element, {
      backgroundColor: '#1a1d29',
      quality: 1.0,
      pixelRatio: 3,
      cacheBust: true,
      width: width,
      height: height,
      style: {
        transform: 'scale(1)',
        transformOrigin: 'top left',
      },
    });
    
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    return { success: true };
  } catch (error) {
    console.error('Capture failed:', error);
    throw error;
  } finally {
    document.body.style.cursor = 'default';
  }
};

export const formatDateForFilename = (dateStr) => {
  const date = new Date(dateStr);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = (date.getFullYear()) % 100;
  return `${day}-${month}-${year}`;
};

export const getDateRangeString = (filteredData) => {
  if (filteredData.length === 0) return '';
  const firstDate = filteredData[0].date;
  const lastDate = filteredData[filteredData.length - 1].date;
  const startDateStr = formatDateForFilename(firstDate);
  const endDateStr = formatDateForFilename(lastDate);
  if (startDateStr === endDateStr) return startDateStr;
  return `{${startDateStr}*${endDateStr}}`;
};